
import React from 'react';

interface TerraceFeatureTagsProps {
  orientation: string;
  hasFood: boolean;
  petFriendly: boolean;
  servesAlcohol: boolean;
}

const TerraceFeatureTags = ({ 
  orientation, 
  hasFood, 
  petFriendly, 
  servesAlcohol 
}: TerraceFeatureTagsProps) => {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <div className="px-3 py-1 rounded-full text-sm bg-red-200">
        {orientation} facing
      </div>
      
      {hasFood && (
        <div className="px-3 py-1 rounded-full text-sm bg-red-200">
          Food
        </div>
      )}
      
      {petFriendly && (
        <div className="bg-secondary px-3 py-1 rounded-full text-sm">
          Pet friendly
        </div>
      )}
      
      {servesAlcohol && (
        <div className="px-3 py-1 rounded-full text-sm bg-red-200">
          Alcohol
        </div>
      )}
    </div>
  );
};

export default TerraceFeatureTags;
